import { PriceToPay } from './PriceToPay'
import { RateCurrency } from 'shared/price-utilities'

const EditBookingPriceBreakdown = ({
    rate,
    oldPrice,
    newPrice,
    editedReservationNewTotalPrice,
    amendmentFee,
    isModal,
}) => {
    const rowStyles = `${isModal ? 'mb-0' : 'mb-3'} d-flex align-items-baseline justify-content-sm-end ${
        isModal && 'justify-content-between justify-content-sm-between'
    }`

    return (
        <>
            <div className={rowStyles}>
                <span>
                    <T>price.breakdown.old.price</T>
                </span>
                <span className="ml-2">
                    <RateCurrency rate={rate} value={oldPrice} />
                </span>
            </div>
            <div className={rowStyles}>
                <span>
                    <T>price.breakdown.new.price</T>
                </span>
                <span className="ml-2">
                    <RateCurrency rate={rate} value={newPrice} />
                </span>
            </div>
            <div className={rowStyles}>
                <span>
                    <T>booking.amendment.fee.label</T>
                </span>
                <span className="ml-2">
                    <RateCurrency rate={rate} value={amendmentFee} />
                </span>
            </div>
            <PriceToPay
                rate={rate}
                label={editedReservationNewTotalPrice.label}
                total={editedReservationNewTotalPrice.amount}
                rowStyles={rowStyles}
            />
        </>
    )
}
export default EditBookingPriceBreakdown
